import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';

const FieldPayerEmail = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-payerEmail',
    defaultMessage: 'Payer email'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'payerEmail'});
  const [checkbox] = useField<boolean>({name: 'payerIsCustomer'});

  return (
    <>
      {!checkbox.value && (
        <InputText
          {...field}
          {...meta}
          variant={'full'}
          id={field.name}
          label={labelText}
          defaultValue={field.value}
          placeholder={placeholder}
        />
      )}
    </>
  );
};

export default FieldPayerEmail;
